import React from "react";

const ModalPopup = (children) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const Modal = ({ children }, isTransparent) => {
    return ( 
      isOpen && (
        <div
          className="fixed h-screen inset-0 overflow-hidden modal-index"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed h-screen inset-0 bg-gray-500 bg-opacity-100 transition-opacity"
              aria-hidden="true"
            ></div>
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div
              className={`inline-block ${isTransparent ? "" : "bg-white"} align-bottom rounded-lg text-left overflow-hidden transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full`}
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-title"
            >
              <div className={`${isTransparent ? "" : "bg-white"} px-4 pt-4 pb-4 sm:p-6 sm:pb-4`}>
                <div className="p-4 sm:flex sm:items-start">
                  <div className="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    {children}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    );
  };
  return { Modal, handleClose, handleOpen };
};

export  default ModalPopup;

